import { Injectable } from '@angular/core';
import { BuddyConfig } from '../buddy-data-structures/buddy-config';

@Injectable({
    providedIn: 'root',
})
export class BuddySettingsService {
    availableLanguages = [
        { language: 'de', localize: $localize`:@@pages.chatbot.settings.language-de:Missing translation` },
        { language: 'en', localize: $localize`:@@pages.chatbot.settings.language-en:Missing translation` },
    ];
    selectedLanguageIndex: number;
    suggestedQuestionsEnabled: boolean;

    constructor() {
        this.selectedLanguageIndex = parseInt(localStorage.getItem('selectedLanguageIndex'), 10) || 0;
        this.suggestedQuestionsEnabled = localStorage.getItem('suggestedQuestionsEnabled')
            ? localStorage.getItem('suggestedQuestionsEnabled') === 'true'
            : true;
    }

    getSelectedLanguage() {
        return this.availableLanguages[this.selectedLanguageIndex];
    }

    getConfig(): BuddyConfig {
        return {
            payloadExtension: {
                locale: this.availableLanguages[this.selectedLanguageIndex].language,
                suggestedQuestionsEnabled: this.suggestedQuestionsEnabled,
            },
        };
    }
}
